import { BlindBoxBuyStatus } from '@/types';
import Mock from 'mockjs';

const MR = Mock.Random;

// 优化点：寻找工具，使用语法进行mock，尽量减少硬编码
export const mockMaps: { [key: string]: (variables: AnyObject) => any } = {
  ['blindBoxActivityData']: (variables) => {
    return {
      id: MR.string(5),
      createdAt: '2024-11-01T12:00:00Z',
      updatedAt: '2024-11-15T08:30:00Z',
      name: '幸运盲盒活动',
      description: '参与活动，赢取超值大奖！',
      startAt: '2024-11-01T12:00:00Z',
      endAt: '2024-12-01T12:00:00Z',
      enabled: true,
      statue: variables.statue,
      isFreeShipping: true,
      freeShippingThreshold: 100,
      price: 29.99,
      baseBlindBoxProbability: 0.05,
      baseBlindBox: {
        id: 'blindBox_001',
        createdAt: '2024-10-01T10:00:00Z',
        updatedAt: '2024-11-01T12:00:00Z',
        wishItemId: 'product_5678',
        price: 29.99,
        name: '精品盲盒',
        description: MR.paragraph(2, 5),
        img: MR.image('200x100', '#16d46b', '#fff', 'png', 'Hello'),
        blindBoxItems: [
          {
            id: 'item_001',
            createdAt: '2024-10-15T10:00:00Z',
            updatedAt: '2024-11-01T12:00:00Z',
            blindBoxId: 'blindBox_001',
            targetId: 'product_5678',
            type: 'normal',
            baseProbability: 0.2,
            isWishItem: true,
            productVariant: {
              id: 'variant_001',
              sku: 'SKU001',
              price: 49.99,
              name: '潮流T恤',
              options: [
                {
                  code: 'color',
                  name: '颜色',
                  group: {
                    code: 'apparel',
                    name: '服装',
                  },
                },
                {
                  code: 'size',
                  name: '尺码',
                  group: {
                    code: 'apparel',
                    name: '服装',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_tshirt.jpg',
              },
            },
          },
          {
            id: 'item_002',
            createdAt: '2024-10-20T11:00:00Z',
            updatedAt: '2024-11-02T14:00:00Z',
            blindBoxId: 'blindBox_001',
            targetId: 'product_6789',
            type: 'rare',
            baseProbability: 0.1,
            isWishItem: false,
            productVariant: {
              id: 'variant_002',
              sku: 'SKU002',
              price: 99.99,
              name: '无线耳机',
              options: [
                {
                  code: 'color',
                  name: '颜色',
                  group: {
                    code: 'electronics',
                    name: '电子产品',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_earbuds.jpg',
              },
            },
          },
        ],
      },
      baseBlindBoxId: 'blindBox_001',
      blindBoxActivityBoxLinks: [
        {
          id: 'link_001',
          createdAt: '2024-11-01T12:00:00Z',
          updatedAt: '2024-11-15T08:30:00Z',
          blindBoxActivity: 'activity_12345',
          blindBoxActivityId: 'activity_12345',
          blindBoxId: 'blindBox_002',
          maxAssistLimit: 3,
          productProbabilities: [
            {
              blindBoxItemId: 'item_003',
              targetProbability: 0.15,
            },
            {
              blindBoxItemId: 'item_004',
              targetProbability: 0.2,
            },
          ],
          blindBoxItems: [
            {
              id: 'item_003',
              createdAt: '2024-10-25T15:00:00Z',
              updatedAt: '2024-11-10T18:00:00Z',
              blindBoxId: 'blindBox_002',
              targetId: 'product_8901',
              type: 'normal',
              baseProbability: 0.3,
              isWishItem: false,
              productVariant: {
                id: 'variant_003',
                sku: 'SKU003',
                price: 39.99,
                name: '运动水壶',
                options: [
                  {
                    code: 'size',
                    name: '容量',
                    group: {
                      code: 'sports',
                      name: '运动用品',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_bottle.jpg',
                },
              },
            },
            {
              id: 'item_004',
              createdAt: '2024-10-30T09:00:00Z',
              updatedAt: '2024-11-12T11:30:00Z',
              blindBoxId: 'blindBox_002',
              targetId: 'product_9012',
              type: 'rare',
              baseProbability: 0.1,
              isWishItem: true,
              productVariant: {
                id: 'variant_004',
                sku: 'SKU004',
                price: 119.99,
                name: '智能手表',
                options: [
                  {
                    code: 'color',
                    name: '颜色',
                    group: {
                      code: 'electronics',
                      name: '电子产品',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_smartwatch.jpg',
                },
              },
            },
          ],
        },
        {
          id: 'link_002',
          createdAt: '2024-11-05T10:00:00Z',
          updatedAt: '2024-11-15T09:00:00Z',
          blindBoxActivity: 'activity_12345',
          blindBoxActivityId: 'activity_12345',
          blindBoxId: 'blindBox_003',
          maxAssistLimit: 5,
          productProbabilities: [
            {
              blindBoxItemId: 'item_005',
              targetProbability: 0.25,
            },
            {
              blindBoxItemId: 'item_006',
              targetProbability: 0.05,
            },
          ],
          blindBoxItems: [
            {
              id: 'item_005',
              createdAt: '2024-10-28T13:00:00Z',
              updatedAt: '2024-11-14T16:00:00Z',
              blindBoxId: 'blindBox_003',
              targetId: 'product_9023',
              type: 'normal',
              baseProbability: 0.4,
              isWishItem: false,
              productVariant: {
                id: 'variant_005',
                sku: 'SKU005',
                price: 59.99,
                name: '无线鼠标',
                options: [
                  {
                    code: 'color',
                    name: '颜色',
                    group: {
                      code: 'electronics',
                      name: '电子产品',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_mouse.jpg',
                },
              },
            },
            {
              id: 'item_006',
              createdAt: '2024-10-29T14:00:00Z',
              updatedAt: '2024-11-14T17:00:00Z',
              blindBoxId: 'blindBox_003',
              targetId: 'product_9024',
              type: 'epic',
              baseProbability: 0.05,
              isWishItem: true,
              productVariant: {
                id: 'variant_006',
                sku: 'SKU006',
                price: 299.99,
                name: '电竞椅',
                options: [
                  {
                    code: 'color',
                    name: '颜色',
                    group: {
                      code: 'furniture',
                      name: '家具',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_chair.jpg',
                },
              },
            },
          ],
        },
      ],
    };
  },
  ['blindBoxActivityPreviewProduct']: () => {
    return {
      baseBlindBox: {
        id: 'blindBox_001',
        createdAt: '2024-10-01T10:00:00Z',
        updatedAt: '2024-11-01T12:00:00Z',
        wishItemId: 'product_5678',
        price: 29.99,
        name: '精品盲盒',
        description: '包含各种惊喜商品，快来试试手气吧！',
        img: 'https://example.com/images/blindbox.jpg',
        blindBoxItems: [
          {
            id: 'item_001',
            createdAt: '2024-10-15T10:00:00Z',
            updatedAt: '2024-11-01T12:00:00Z',
            blindBoxId: 'blindBox_001',
            targetId: 'product_5678',
            type: 'normal',
            baseProbability: 0.2,
            isWishItem: true,
            productVariant: {
              id: 'variant_001',
              sku: 'SKU001',
              price: 49.99,
              name: '潮流T恤',
              options: [
                {
                  code: 'color',
                  name: '颜色',
                  group: {
                    code: 'apparel',
                    name: '服装',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_tshirt.jpg',
              },
            },
          },
          {
            id: 'item_002',
            createdAt: '2024-10-16T10:00:00Z',
            updatedAt: '2024-11-02T12:00:00Z',
            blindBoxId: 'blindBox_001',
            targetId: 'product_6789',
            type: 'rare',
            baseProbability: 0.1,
            isWishItem: false,
            productVariant: {
              id: 'variant_002',
              sku: 'SKU002',
              price: 99.99,
              name: '无线耳机',
              options: [
                {
                  code: 'size',
                  name: '大小',
                  group: {
                    code: 'electronics',
                    name: '电子产品',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_earbuds.jpg',
              },
            },
          },
        ],
      },
      wishBlindBox: {
        id: 'blindBox_002',
        createdAt: '2024-10-10T11:00:00Z',
        updatedAt: '2024-11-05T14:00:00Z',
        wishItemId: 'product_7890',
        price: 59.99,
        name: '稀有盲盒',
        description: '更多机会获取稀有奖励！',
        img: 'https://example.com/images/blindbox_rare.jpg',
        blindBoxItems: [
          {
            id: 'item_003',
            createdAt: '2024-10-20T11:00:00Z',
            updatedAt: '2024-11-06T12:00:00Z',
            blindBoxId: 'blindBox_002',
            targetId: 'product_7890',
            type: 'epic',
            baseProbability: 0.05,
            isWishItem: true,
            productVariant: {
              id: 'variant_003',
              sku: 'SKU003',
              price: 149.99,
              name: '高端手表',
              options: [
                {
                  code: 'material',
                  name: '材质',
                  group: {
                    code: 'accessories',
                    name: '配件',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_watch.jpg',
              },
            },
          },
          {
            id: 'item_004',
            createdAt: '2024-10-21T12:00:00Z',
            updatedAt: '2024-11-06T12:30:00Z',
            blindBoxId: 'blindBox_002',
            targetId: 'product_8910',
            type: 'rare',
            baseProbability: 0.15,
            isWishItem: false,
            productVariant: {
              id: 'variant_004',
              sku: 'SKU004',
              price: 89.99,
              name: '便携音箱',
              options: [
                {
                  code: 'color',
                  name: '颜色',
                  group: {
                    code: 'electronics',
                    name: '电子产品',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_speaker.jpg',
              },
            },
          },
        ],
      },
    };
  },
  ['blindBoxOpenbox']: (variables) => {
    return {
      id: 'openbox_12345',
      createdAt: '2024-11-20T12:00:00Z',
      updatedAt: '2024-11-21T10:30:00Z',
      blindBoxBuy: {
        id: 'buy_67890',
        assistExpireAt: '2024-11-22T12:00:00Z',
        createdAt: '2024-11-20T10:00:00Z',
        updatedAt: '2024-11-20T12:30:00Z',
        customer: 'customer_abc123',
        customerId: 'customer_abc123',
        baseBlindBox: {
          id: 'blindBox_001',
          createdAt: '2024-10-01T10:00:00Z',
          updatedAt: '2024-11-01T12:00:00Z',
          wishItemId: 'product_5678',
          price: 29.99,
          name: '精品盲盒',
          description: '包含各种惊喜商品，快来试试手气吧！',
          img: 'https://example.com/images/blindbox.jpg',
          blindBoxItems: [
            {
              id: 'item_001',
              createdAt: '2024-10-15T10:00:00Z',
              updatedAt: '2024-11-01T12:00:00Z',
              blindBoxId: 'blindBox_001',
              targetId: 'product_5678',
              type: 'normal',
              baseProbability: 0.2,
              isWishItem: true,
              productVariant: {
                id: 'variant_001',
                sku: 'SKU001',
                price: 49.99,
                name: '潮流T恤',
                options: [
                  {
                    code: 'color',
                    name: '颜色',
                    group: {
                      code: 'apparel',
                      name: '服装',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_tshirt.jpg',
                },
              },
            },
          ],
        },
        baseBlindBoxId: 'blindBox_001',
        wishBlindBox: {
          id: 'blindBox_002',
          createdAt: '2024-10-10T11:00:00Z',
          updatedAt: '2024-11-01T12:00:00Z',
          wishItemId: 'product_6789',
          price: 59.99,
          name: '稀有盲盒',
          description: '更多机会获取稀有奖励！',
          img: 'https://example.com/images/blindbox_rare.jpg',
          blindBoxItems: [
            {
              id: 'item_002',
              createdAt: '2024-10-20T11:00:00Z',
              updatedAt: '2024-11-02T14:00:00Z',
              blindBoxId: 'blindBox_002',
              targetId: 'product_6789',
              type: 'rare',
              baseProbability: 0.1,
              isWishItem: true,
              productVariant: {
                id: 'variant_002',
                sku: 'SKU002',
                price: 99.99,
                name: '无线耳机',
                options: [
                  {
                    code: 'color',
                    name: '颜色',
                    group: {
                      code: 'electronics',
                      name: '电子产品',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_earbuds.jpg',
                },
              },
            },
          ],
        },
        wishBlindBoxId: 'blindBox_002',
        paymentMetadata: {
          transactionId: 'tx_123456',
          method: 'credit_card',
          status: 'success',
        },
        status: 'completed',
        payStatus: 'paid',
        paymentAt: '2024-11-20T12:00:00Z',
        assistLimit: 3,
        assistCount: 2,
        assistAt: '2024-11-20T14:00:00Z',
      },
      blindBoxBuyId: 'buy_67890',
      blindBox: {
        id: 'blindBox_001',
        createdAt: '2024-10-01T10:00:00Z',
        updatedAt: '2024-11-01T12:00:00Z',
        wishItemId: 'product_5678',
        price: 29.99,
        name: '精品盲盒',
        description: '包含各种惊喜商品，快来试试手气吧！',
        img: 'https://example.com/images/blindbox.jpg',
        blindBoxItems: [
          {
            id: 'item_001',
            createdAt: '2024-10-15T10:00:00Z',
            updatedAt: '2024-11-01T12:00:00Z',
            blindBoxId: 'blindBox_001',
            targetId: 'product_5678',
            type: 'normal',
            baseProbability: 0.2,
            isWishItem: true,
            productVariant: {
              id: 'variant_001',
              sku: 'SKU001',
              price: 49.99,
              name: '潮流T恤',
              options: [
                {
                  code: 'color',
                  name: '颜色',
                  group: {
                    code: 'apparel',
                    name: '服装',
                  },
                },
              ],
              featuredAsset: {
                source: 'https://example.com/images/product_tshirt.jpg',
              },
            },
          },
        ],
      },
      blindBoxId: 'blindBox_001',
      customer: {
        id: 'customer_abc123',
      },
      customerId: 'customer_abc123',
      blindBoxItem: {
        id: 'item_001',
        createdAt: '2024-10-15T10:00:00Z',
        updatedAt: '2024-11-01T12:00:00Z',
        blindBoxId: 'blindBox_001',
        targetId: 'product_5678',
        type: 'normal',
        baseProbability: 0.2,
        isWishItem: true,
        productVariant: {
          id: 'variant_001',
          sku: 'SKU001',
          price: 49.99,
          name: '潮流T恤',
          options: [
            {
              code: 'color',
              name: '颜色',
              group: {
                code: 'apparel',
                name: '服装',
              },
            },
          ],
          featuredAsset: {
            source: 'https://example.com/images/product_tshirt.jpg',
          },
        },
      },
      resultId: 'result_8901',
      isWishedItem: variables.openboxWish,
      openedAt: '2024-11-20T12:15:00Z',
      assistCount: 2,
      currentAllProbability: 0.35,
    };
  },
  ['blindBoxBuy']: (variables) => {
    return [
      {
        id: 'buy_0001',
        createdAt: '2024-11-20T12:00:00Z',
        updatedAt: '2024-11-21T15:00:00Z',
        customer: 'customer_xyz',
        customerId: 'customer_1234',
        code: 'BX001-A',
        wishBlindBoxItem: {
          id: 'item_003',
          createdAt: '2024-10-16T12:00:00Z',
          updatedAt: '2024-11-01T14:00:00Z',
          blindBoxId: 'blindBox_001',
          targetId: 'product_8901',
          type: 'epic',
          baseProbability: 0.1,
          isWishItem: true,
          productVariant: {
            id: 'variant_003',
            sku: 'SKU003',
            price: 149.99,
            name: '高端手表',
            options: [
              {
                code: 'material',
                name: '材质',
                group: {
                  code: 'accessories',
                  name: '配件',
                },
              },
            ],
            featuredAsset: {
              source: 'https://example.com/images/product_watch.jpg',
            },
          },
        },
        blindBoxOpenRecord: [
          {
            id: 'record_001',
            createdAt: '2024-11-20T12:30:00Z',
            updatedAt: '2024-11-21T15:00:00Z',
            blindBoxBuyId: 'buy_0001',
            blindBox: {
              id: 'blindBox_001',
              createdAt: '2024-11-01T10:00:00Z',
              updatedAt: '2024-11-20T12:00:00Z',
              wishItemId: 'product_123',
              price: 29.99,
              name: '幸运盲盒',
              description: '包含多种惊喜商品，提升中奖概率！',
              img: 'https://example.com/images/blindbox_001.jpg',
              blindBoxItems: [
                {
                  id: 'item_001',
                  createdAt: '2024-10-15T10:00:00Z',
                  updatedAt: '2024-11-01T12:00:00Z',
                  blindBoxId: 'blindBox_001',
                  targetId: 'product_5678',
                  type: 'normal',
                  baseProbability: 0.3,
                  isWishItem: true,
                  productVariant: {
                    id: 'variant_001',
                    sku: 'SKU001',
                    price: 49.99,
                    name: '潮流T恤',
                    options: [
                      {
                        code: 'color',
                        name: '颜色',
                        group: {
                          code: 'apparel',
                          name: '服装',
                        },
                      },
                    ],
                    featuredAsset: {
                      source: 'https://example.com/images/product_tshirt.jpg',
                    },
                  },
                },
                {
                  id: 'item_002',
                  createdAt: '2024-10-15T10:00:00Z',
                  updatedAt: '2024-11-01T12:00:00Z',
                  blindBoxId: 'blindBox_001',
                  targetId: 'product_6789',
                  type: 'rare',
                  baseProbability: 0.15,
                  isWishItem: false,
                  productVariant: {
                    id: 'variant_002',
                    sku: 'SKU002',
                    price: 99.99,
                    name: '无线耳机',
                    options: [
                      {
                        code: 'size',
                        name: '大小',
                        group: {
                          code: 'electronics',
                          name: '电子产品',
                        },
                      },
                    ],
                    featuredAsset: {
                      source: 'https://example.com/images/product_earbuds.jpg',
                    },
                  },
                },
              ],
            },
            blindBoxId: 'blindBox_001',
            customer: { id: 'customer_1234' },
            customerId: 'customer_1234',
            blindBoxItem: {
              id: 'item_003',
              createdAt: '2024-10-16T12:00:00Z',
              updatedAt: '2024-11-01T14:00:00Z',
              blindBoxId: 'blindBox_001',
              targetId: 'product_8901',
              type: 'epic',
              baseProbability: 0.1,
              isWishItem: false,
              productVariant: {
                id: 'variant_003',
                sku: 'SKU003',
                price: 149.99,
                name: '高端手表',
                options: [
                  {
                    code: 'material',
                    name: '材质',
                    group: {
                      code: 'accessories',
                      name: '配件',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_watch.jpg',
                },
              },
            },
            resultId: 'result_001',
            isWishedItem: variables.openboxWish || true,
            openedAt: '2024-11-20T12:30:00Z',
            assistCount: 3,
            currentAllProbability: 0.25,
          },
        ],
        baseBlindBox: {
          id: 'blindBox_001',
          createdAt: '2024-11-01T10:00:00Z',
          updatedAt: '2024-11-20T12:00:00Z',
          wishItemId: 'product_123',
          price: 29.99,
          name: '幸运盲盒',
          description: '包含多种惊喜商品，提升中奖概率！',
          img: 'https://example.com/images/blindbox_001.jpg',
          blindBoxItems: [
            {
              id: 'item_001',
              createdAt: '2024-10-15T10:00:00Z',
              updatedAt: '2024-11-01T12:00:00Z',
              blindBoxId: 'blindBox_001',
              targetId: 'product_5678',
              type: 'normal',
              baseProbability: 0.3,
              isWishItem: true,
              productVariant: {
                id: 'variant_001',
                sku: 'SKU001',
                price: 49.99,
                name: '潮流T恤',
                options: [
                  {
                    code: 'color',
                    name: '颜色',
                    group: {
                      code: 'apparel',
                      name: '服装',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_tshirt.jpg',
                },
              },
            },
            {
              id: 'item_002',
              createdAt: '2024-10-15T10:00:00Z',
              updatedAt: '2024-11-01T12:00:00Z',
              blindBoxId: 'blindBox_001',
              targetId: 'product_6789',
              type: 'rare',
              baseProbability: 0.15,
              isWishItem: false,
              productVariant: {
                id: 'variant_002',
                sku: 'SKU002',
                price: 99.99,
                name: '无线耳机',
                options: [
                  {
                    code: 'size',
                    name: '大小',
                    group: {
                      code: 'electronics',
                      name: '电子产品',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_earbuds.jpg',
                },
              },
            },
          ],
        },
        baseBlindBoxId: 'blindBox_001',
        wishBlindBox: {
          id: 'blindBox_002',
          createdAt: '2024-11-01T11:00:00Z',
          updatedAt: '2024-11-20T12:30:00Z',
          wishItemId: 'product_234',
          price: 39.99,
          name: '豪华盲盒',
          description: '更多稀有物品，更多惊喜！',
          img: 'https://example.com/images/blindbox_002.jpg',
          blindBoxItems: [
            {
              id: 'item_003',
              createdAt: '2024-10-20T11:00:00Z',
              updatedAt: '2024-11-06T12:00:00Z',
              blindBoxId: 'blindBox_002',
              targetId: 'product_7890',
              type: 'epic',
              baseProbability: 0.1,
              isWishItem: true,
              productVariant: {
                id: 'variant_003',
                sku: 'SKU003',
                price: 149.99,
                name: '高端手表',
                options: [
                  {
                    code: 'material',
                    name: '材质',
                    group: {
                      code: 'accessories',
                      name: '配件',
                    },
                  },
                ],
                featuredAsset: {
                  source: 'https://example.com/images/product_watch.jpg',
                },
              },
            },
          ],
        },
        wishBlindBoxId: 'blindBox_002',
        paymentMetadata: {
          transactionId: 'tx_123456',
          method: 'credit_card',
          status: 'completed',
        },
        status: variables.buyStatus || BlindBoxBuyStatus.assisting,
        payStatus: 'paid',
        paymentAt: '2024-11-20T12:30:00Z',
        assistLimit: 5,
        assistCount: 4,
        assistAt: '2024-12-01T12:00:00Z',
      },
    ];
  },
  ['blindBoxBuyDetail']: (variables) => {
    const data: AnyObject[] = mockMaps['blindBoxBuy']({});
    return data.find((it) => it.id === variables.id);
  },
  ['getBlindBoxBuyByOrderId']: (variables) => {
    const data: AnyObject[] = mockMaps['blindBoxBuy']({});
    return data.find((it) => it.id === variables.blindBoxBuyId);
  },
};
